'use strict';

export default angular.module('contartemx.contacto', [
 	'contartemx',
    'ui.router',
    'ngTable',
    'ui.bootstrap',
    'datePicker',
    "tableTools",
    "loader"
])

.config(function contactoConfig($stateProvider){

	$stateProvider.state('contacto',{
		url:'/Contacto',
		views:
		{
			'':{
        template: require('../../../../app/views/Contacto/Contacto_main.html'),
				controller: 'ContactoCtrl'
			}
		}
    });
  }
).controller('ContactoCtrl', [
  '$scope',
  '$state',
  '$stateParams',
  '$filter',
  '$http',
  'callToWebService',
  '$timeout',
  'mostrarNotificacion',
  function ContactoController($scope, $state, $stateParams, $filter, $http, callToWebService, $timeout, mostrarNotificacion) {
    $scope.placeholdertext = 'Por favor proporciona tantos detalles como puedas. Entre más especifico seas, más rápido podremos resolver el problema.';
    $scope.closeAlert = function () {
		$scope.alert = [];
	};

	$scope.llamadoInicial = 1;
	$scope.$watch("llamadoInicial", function () {


	    callToWebService.postCall('PantallaContacto', {},
	        function success(data) {
	        	$scope.datos = data.Respuesta;
	        },
	        function error(data) {

	        });

	}, true);

	$scope.interval = function(){
		var horaLocal = moment().tz('America/Tijuana').format("hh");
		var msjHora='son las ';
		if(parseInt(horaLocal) == 1){
			msjHora='es la ';
		}
		
		$scope.msgHora = 'Ahora ' + msjHora;
		$scope.msgHora2 = 'en nuestra oficina.';		
		$scope.hora = moment().tz('America/Tijuana').format("hh:mm a");
		$scope.clock = $timeout($scope.interval, 1000);
	};

	$scope.clock = $timeout($scope.interval, 1000);

	$scope.$on('$destroy', function(){
		$timeout.cancel($scope.clock);
	});

	$scope.sendMessage = function(form){
		if(form.$valid)
		{
			 var dataInfo = {
                    datos:{
                        Nombre : form.nombre.$viewValue,
				        Correo  : form.correo.$viewValue,
				        Asunto  : form.asunto.$viewValue,
				        Mensaje  : form.mensaje.$viewValue
                    }
                };

            callToWebService.postCall('PantallaContacto', dataInfo,
                function success(data) {
                	$scope.nombre = '';
                	$scope.correo = '';
                	$scope.asunto = '';
                	$scope.mensaje = '';

            		$scope.alert = [{ type: 'info', msg: 'Mensaje enviado. Nos comunicaremos contigo lo antes posible.'}]; 
                },
                function error(data) {
                });
		}
		else
		{
			var mensaje ='';
			var notificacion = false;
			if(form.nombre.$invalid | form.asunto.$invalid | form.mensaje.$invalid)
			{
				mensaje ='Por favor completa todos los campos para poder comunicarnos contigo. ';
				notificacion = true;
			}

			if(form.correo.$invalid && form.correo.$viewValue)
			{
				mensaje = mensaje+'Verifica que tu dirección de correo sea valida.';
			}
			if(form.correo.$viewValue == "" && !notificacion)
			{
				mensaje = mensaje+'Por favor completa todos los campos para poder comunicarnos contigo. ';
			}
			else
			{
				if(form.correo.$viewValue == null && !notificacion)
					mensaje = mensaje+'Por favor completa todos los campos para poder comunicarnos contigo. ';
			}
			$scope.alert = [{ type: 'error', msg: mensaje }];
		}
	 }
}
]);
